/* eslint-disable react/jsx-indent */
import React, { Component } from 'react'
import {
  Card, CardBody, Col, CardHeader, ModalFooter,
  Row, Button, Modal, ModalHeader, ModalBody,
  Label, FormGroup,
  Input} from 'reactstrap'
import Select from '../../../components/Template/Input/Select'
import { selectValues, getRegs, insOrUp } from '../../../utils/fc'
import DataTable from '../../../components/Template/Table/DataTable'
import DatePicker from 'react-datepicker'
import moment from 'moment'

class Vagas extends Component {
  constructor(props) {
    super(props)
    this.state = {
      data: false,
      dataIsLoading: false,

      addEquiProjModalIsOpen: false,
      addEquiProjData: {},

      selEquiProj: false,
      equi: {},

    }
  }

  componentDidMount() {
    this.preloading()
  }

  preloading = async() => {
    this.setState({dataIsLoading: true })
    const data = await getRegs('projEquipe', {proj_id: this.props.projId },
    {
      'pf_id': 'id_do_cidadao',
			'(SELECT pf_nomeExibicao FROM pf WHERE pf.pf_id = projEquipe.pf_id)': 'pf_nomeExibicao',
      '(SELECT pf_cargo FROM pf WHERE pf.pf_id = projEquipe.pf_id)': 'pf_cargo',
      '(SELECT pf_numCons FROM pf WHERE pf.pf_id = projEquipe.pf_id)': 'pf_numCons',
      '(SELECT projAtuacao_nome FROM projAtuacao WHERE projAtuacao.projAtuacao_id = projEquipe.projAtuacao_id)': 'projAtuacao_nome'
		} )
    console.log("lista do EquiProj ", data)
    this.setState({ data, dataIsLoading: false })

    this.setState({ selEquiProj: await selectValues('pf', 'pf_id', 'pf_nomeExibicao', {dpto_id: 4}) })
    console.log('lista pf = ', this.state.selEquiProj)
    this.setState({ selAtuaProj: await selectValues('projAtuacao', 'projAtuacao_id', 'projAtuacao_nome') })
    console.log('lista atuação = ', this.state.selAtuaProj)
  }

  render() {

    const { dataIsLoading, data, addEquiProjData , addEquiProjModalIsOpen, selEquiProj, selAtuaProj } = this.state


    if (dataIsLoading) {
      return (
        <Card>
          <CardBody>
            <span>Carregando...</span>
          </CardBody>
        </Card>
      )
    }

    if (data) {
      return (
          <>
            <Button
              size="sm"
              color="link"
              className="mb-1 ml-1 px-0"
              onClick={() => this.setState({
                addEquiProjModalIsOpen: true,
                addEquiProjData: { proj_id: this.props.projId },
              })}
            >
              Adicionar novo
            </Button>
            <Modal
              size='lg'
              centered={false}
              isOpen={ addEquiProjModalIsOpen}
              toggle={() => this.setState({ addEquiProjData: {}, addEquiProjModalIsOpen: false })}
            >
              <ModalHeader
                toggle={() => this.setState({
                addEquiProjData: {},
                addEquiProjModalIsOpen: false,
              })}
              >
                Abertura de Vagas
              </ModalHeader>
              <ModalBody>
                <Row>
                  <Col>
                    <FormGroup>
                      <Label>
                        Nome
                      </Label>
                      <Input
                        onChange={e => console.log(e)}
                      />
                    </FormGroup>
                  </Col>
                  <Col>
                    <FormGroup>
                      <Label>
                        Área
                      </Label>
                      <Input
                        onChange={e => console.log(e)}
                      />
                    </FormGroup>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <FormGroup>
                      <Label>
                        Recrutador Responsável
                      </Label>
                      <Input
                        onChange={e => console.log(e)}
                      />
                    </FormGroup>
                  </Col>
                  <Col>
                    <FormGroup>
                      <Label>
                        SLA
                      </Label>
                      <Input
                        onChange={e => console.log(e)}
                      />
                    </FormGroup>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <FormGroup>
                      <Label>
                        Notas Internas
                      </Label>
                      <Input
                        type='textarea'
                        onChange={e => console.log(e)}
                      />
                    </FormGroup>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <FormGroup>
                      <Label>
                        Cargo
                      </Label>
                      <Input
                        onChange={e => console.log(e)}
                      />
                    </FormGroup>
                  </Col>
                  <Col>
                    <FormGroup>
                      <Label>
                        Senioridade
                      </Label>
                      <Input
                        onChange={e => console.log(e)}
                      />
                    </FormGroup>
                  </Col>
                </Row>
                <div className='d-flex align-items-center todolist mt-4'>
                  <div className='d-flex align-items-center justify-content-center w-100'>
                    <div className='d-flex flex-column align-items-center justify-content-center flex-grow-1 mr-2'>
                      <label className='w-100 text-start'>Quantidade de posições</label>
                      <Input
                      />
                    </div>
                    <div className='d-flex flex-column align-items-center justify-content-center flex-grow-1 mr-2'>
                      <label className='w-100 text-start'>Motivo das posições</label>
                      <Input
                      />
                    </div>
                  </div>
                </div>
                <Row className='mt-5'>
                  <Col>
                    <FormGroup>
                      <Label>
                        Formação profissional
                      </Label>
                      <Input
                        onChange={e => console.log(e)}
                      />
                    </FormGroup>
                  </Col>
                  <Col>
                    <FormGroup>
                      <Label>
                        Atestados necessários
                      </Label>
                      <Input
                        onChange={e => console.log(e)}
                      />
                    </FormGroup>
                  </Col>
                  <Col>
                    <FormGroup>
                      <Label>
                        Equipe interna
                      </Label>
                      <Input
                        onChange={e => console.log(e)}
                      />
                    </FormGroup>
                  </Col>
                </Row>
                <FormGroup
                  row
                  tag="fieldset"
                >
                  <legend className="col-form-label col-sm-10">
                    Tipo de contratação
                  </legend>
                  <Col>
                    <div className='d-flex'>
                      <FormGroup check>
                        <Input
                          name="radio2"
                          type="radio"
                          />
                        {' '}
                        <Label check className='mr-3'>
                          CLT
                        </Label>
                      </FormGroup>
                      <FormGroup check>
                        <Input
                          name="radio2"
                          type="radio"
                          />
                        {' '}
                        <Label check className='mr-3'>
                          PJ
                        </Label>
                      </FormGroup>
                      <FormGroup
                        check
                      >
                        <Input
                          name="radio2"
                          type="radio"
                          />
                        {' '}
                        <Label check className='mr-3'>
                          Cooperado
                        </Label>
                      </FormGroup>
                      <FormGroup
                        check
                      >
                        <Input
                          name="radio2"
                          type="radio"
                          />
                        {' '}
                        <Label check className='mr-3'>
                          Estágio
                        </Label>
                      </FormGroup>
                      <FormGroup
                        check
                      >
                        <Input
                          name="radio2"
                          type="radio"
                          />
                        {' '}
                        <Label check className='mr-3'>
                          Menor Aprendiz
                        </Label>
                      </FormGroup>
                      <FormGroup
                        check
                      >
                        <Input
                          name="radio2"
                          type="radio"
                          />
                        {' '}
                        <Label check className='mr-3'>
                          Autônomo
                        </Label>
                      </FormGroup>
                    </div>
                  </Col>
                </FormGroup>
                <Row>
                  <Col>
                    <FormGroup>
                      <Label>
                        Salário ideal
                      </Label>
                      <Input
                        onChange={e => console.log(e)}
                      />
                    </FormGroup>
                  </Col>
                  <Col>
                    <FormGroup>
                      <Label>
                        Salário máximo
                      </Label>
                      <Input
                        onChange={e => console.log(e)}
                      />
                    </FormGroup>
                  </Col>
                </Row>
                <FormGroup
                  row
                  tag="fieldset"
                >
                  <legend className="col-form-label col-sm-10">
                    Remota ou presencial
                  </legend>
                  <Col>
                    <div className='d-flex'>
                      <FormGroup check>
                        <Input
                          name="radio2"
                          type="radio"
                          />
                        {' '}
                        <Label check className='mr-3'>
                          Presencial
                        </Label>
                      </FormGroup>
                      <FormGroup check>
                        <Input
                          name="radio2"
                          type="radio"
                          />
                        {' '}
                        <Label check className='mr-3'>
                          Remoto
                        </Label>
                      </FormGroup>
                      <FormGroup
                        check
                      >
                        <Input
                          name="radio2"
                          type="radio"
                          />
                        {' '}
                        <Label check className='mr-3'>
                          Híbrido
                        </Label>
                      </FormGroup>
                    </div>
                  </Col>
                </FormGroup>
                <Row>
                  <Col>
                    <FormGroup>
                      <Label>
                        País
                      </Label>
                      <Input
                        onChange={e => console.log(e)}
                      />
                    </FormGroup>
                  </Col>
                  <Col>
                    <FormGroup>
                      <Label>
                        Estado
                      </Label>
                      <Input
                        onChange={e => console.log(e)}
                      />
                    </FormGroup>
                  </Col>
                  <Col>
                    <FormGroup>
                      <Label>
                        Cidade
                      </Label>
                      <Input
                        onChange={e => console.log(e)}
                      />
                    </FormGroup>
                  </Col>
                </Row>
                <FormGroup
                  row
                  tag="fieldset"
                >
                  <legend className="col-form-label col-sm-10">
                    Benefícios
                  </legend>
                  <Col>
                    <div className='d-flex'>
                      <FormGroup check>
                        <Input
                          name="radio2"
                          type="radio"
                          />
                        {' '}
                        <Label check className='mr-3'>
                          Aux. Moradia
                        </Label>
                      </FormGroup>
                      <FormGroup check>
                        <Input
                          name="radio2"
                          type="radio"
                          />
                        {' '}
                        <Label check className='mr-3'>
                          Aux. Transporte
                        </Label>
                      </FormGroup>
                      <FormGroup
                        check
                      >
                        <Input
                          name="radio2"
                          type="radio"
                          />
                        {' '}
                        <Label check className='mr-3'>
                          Aux. Alimentação
                        </Label>
                      </FormGroup>
                      <FormGroup
                        check
                      >
                        <Input
                          name="radio2"
                          type="radio"
                          />
                        {' '}
                        <Label check className='mr-3'>
                          Acesso ao Office 365
                        </Label>
                      </FormGroup>
                      <FormGroup
                        check
                      >
                        <Input
                          name="radio2"
                          type="radio"
                          />
                        {' '}
                        <Label check className='mr-3'>
                          E-mail Coorporativo
                        </Label>
                      </FormGroup>
                    </div>
                  </Col>
                </FormGroup>
              </ModalBody>
              <ModalFooter>
                <Button
                  type="button"
                  onClick={() => this.setState({ addEquiProjData: {}, addEquiProjModalIsOpen: false })}
                  color="light"
                  className="waves-effect"
                >
                  Cancelar
                </Button>
                <Button
                  type="button"
                  color="primary"
                  className="waves-effect waves-light"
                  onClick={() => {
                    insOrUp( 'projEquipe', addEquiProjData)
                    this.preloading()
                    this.setState({ addEquiProjData: {}, addEquiProjModalIsOpen: false })

                  }
                  }

                >
                  Adicionar
                </Button>
              </ModalFooter>
            </Modal>
          </>
      )
    }

    return null
  }
}
export default Vagas
